import { DialogComponentContent } from './../../../models/dialogs/DialogComponentContent';
import { Component, Inject, ElementRef, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    templateUrl: './simple.component.html',
    styleUrls: ['./simple.component.scss'],
})

export class SimpleModalComponent extends DialogComponentContent {
    public iconId: string;
    public iconType: string;
    public title: string;
    public message: string;
    public confirmButtonLabel: string;
    public showCloseButton: string;
    public onButtonClick?: () => void;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<SimpleModalComponent>,
        public element: ElementRef,
    ) {
        super(element);

        if (data && data.iconId) {
            this.iconId = data.iconId;
            this.iconType = data.iconType;
        }

        if (data && data.title) {
            this.title = data.title;
        }

        if (data && data.message) {
            this.message = data.message;
        }

        if (data && data.buttonLabel) {
            this.confirmButtonLabel = data.buttonLabel;
        }

        this.showCloseButton = data.showCloseButton;
        this.onButtonClick = data.onButtonClick;
    }

    public handleButtonClick(): void {
        if (this.onButtonClick) {
            this.onButtonClick();
        }
        this.dispose(true);
    }

    public dispose(result: boolean): void {
        this.dialogRef.close(result);
    }
}
